import { render, staticRenderFns } from "./ProductInner.vue?vue&type=template&id=7e6198d4&scoped=true"
import script from "./ProductInner.vue?vue&type=script&lang=js"
export * from "./ProductInner.vue?vue&type=script&lang=js"
import style0 from "./ProductInner.vue?vue&type=style&index=0&id=7e6198d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6198d4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EducationStreamListFirstTimeSelect: require('/builds/gb-developers/geekbrains-client/components/pages/education/StreamList/FirstTimeSelect.vue').default,EducationProgramsListChapterInfo: require('/builds/gb-developers/geekbrains-client/components/pages/education/ProgramsList/ChapterInfo.vue').default,EducationCourseCard: require('/builds/gb-developers/geekbrains-client/components/pages/education/CourseCard/CourseCard.vue').default})
